import { render, staticRenderFns } from "./main.vue?vue&type=template&id=bad3fe7a&scoped=true&"
import script from "./main.vue?vue&type=script&lang=js&"
export * from "./main.vue?vue&type=script&lang=js&"
import style0 from "./main.vue?vue&type=style&index=0&id=bad3fe7a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bad3fe7a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/wp/Desktop/chuanti-pc/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bad3fe7a')) {
      api.createRecord('bad3fe7a', component.options)
    } else {
      api.reload('bad3fe7a', component.options)
    }
    module.hot.accept("./main.vue?vue&type=template&id=bad3fe7a&scoped=true&", function () {
      api.rerender('bad3fe7a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/UploadImgCropperNew/main.vue"
export default component.exports